// src/firebase.js

import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB06_zvohjkG-h377-IFP4NbWxnDyJoCcM",
  authDomain: "rthcleaners-63c92.firebaseapp.com",
  projectId: "rthcleaners-63c92",
  storageBucket: "rthcleaners-63c92.firebasestorage.app",  // <- fix typo (must be `.appspot.com`)
  messagingSenderId: "493008804670",
  appId: "1:493008804670:web:163a14184cdcb177896a6f",
  measurementId: "G-QZESJ7T2XW"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Export Firebase services
const db = getFirestore(app)
const auth = getAuth(app)
const storage = getStorage(app)

export { db, auth, storage }
